<template>
    <div class="content">
        <div class="operateBtn" v-if="!submitSuccess && tokenIsEffect">
            <a-button class="submit" type="primary" size="small"  :disabled="!confirm || loading" @click="submit">{{ $t('dealerForm.submit') }}</a-button>
            <a-space size="large" class="language">
                <a-select 
                    v-model="language"
                    :style="{width:'120px',float:'right'}" 
                    :placeholder="t('dealerForm.language')"
                    :disabled="submitSuccess"
                    @change="switchLanguage"
                >
                    <a-option value="en">English</a-option>
                    <a-option value="de">Deutsch</a-option>
                </a-select>
                <Avatar></Avatar>
            </a-space>
        </div>
        
        <a-spin dot :loading="loading" :tip="$t('dealerForm.submitting')">
            <div class="container" id="pdfHtml" v-if="!submitSuccess && tokenIsEffect">
                <a-watermark content="HEPHA">
                    <img class="logo" src="@/assets/image/hepha-logo-black2.jpg" width="200" height="80"/> 
                    <div class="title">
                        <p class="title_hd">{{ $t('dealerForm.title') }}</p>
                        <p class="title_content">{{ $t('dealerForm.subTitle') }}</p>
                    </div>
                    <div class="form form1">
                            <div class="form_item">
                                <span class="item_field">{{ $t('dealerForm.companyName') }} <i style="color:red">*</i></span>
                                <input type="text" class="form_input" :style="{width:'585px'}" maxlength="500" v-model="formData.company_name">
                            </div>
                            <div class="form_item">
                                <span class="item_field">{{ $t('dealerForm.contactPerson') }} <i style="color:red">*</i></span>
                                <input type="text" class="form_input" :style="{width:'585px'}" maxlength="255" v-model="formData.contact_person">
                            </div>
                            <div class="form_item">
                                <div class="form_item_sub">
                                    <span class="item_field">{{ $t('dealerForm.street') }} <i style="color:red">*</i></span>
                                    <input type="text" class="form_input" :style="{width:'300px'}" maxlength="255" v-model="formData.street">
                                </div>
                                <div class="form_item_sub">
                                    <span class="item_field" style="width: 120px">{{ $t('dealerForm.houseNumber') }} <i style="color:red">*</i></span>
                                    <input type="text" class="form_input" :style="{width:'135px'}" maxlength="255" v-model="formData.house_number">
                                </div>
                            </div>
                            <div class="form_item">
                                <div class="form_item_sub">
                                    <span class="item_field">{{ $t('dealerForm.zipCode') }} <i style="color:red">*</i></span>
                                    <input type="text" class="form_input" :style="{width:'165px'}" maxlength="50" v-model="formData.zip">
                                </div>
                                <div class="form_item_sub">
                                    <span class="item_field" style="width: 80px">{{ $t('dealerForm.location') }} </span>
                                    <input type="text" class="form_input" :style="{width:'310px'}" maxlength="100" v-model="formData.location">
                                </div>
                            </div>
                            <div class="form_item">
                                <div class="form_item_sub">
                                    <span class="item_field">{{ $t('dealerForm.country') }} <i style="color:red">*</i></span>
                                    <div class="select">
                                        <input type="text" class="form_input" readonly :style="{width:'235px',cursor:'pointer'}" v-model="formData.country" @click="showCountrySelect = true">
                                        <a-select
                                            v-if="showCountrySelect"
                                            class="form_select"
                                            v-model="formData.country_code" 
                                            :style="{width:'257px',marginLeft:'-256px'}" 
                                            allow-search
                                            :placeholder="$t('dealerForm.pleaseSelect')" 
                                            @change="selectCountry"
                                        >
                                            <a-option
                                                v-for="(item,index) in countryOptions"
                                                :key="index"
                                                :value="item.value"
                                            >{{ item.label }}</a-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div class="form_item_sub">
                                    <span class="item_field" style="width: 80px">{{ $t('dealerForm.city') }} <i style="color:red">*</i></span>
                                    <input type="text" class="form_input" :style="{width:'240px'}" maxlength="255" v-model="formData.city">
                                </div>
                            </div>
                            <div class="form_item">
                                <div class="form_item_sub">
                                    <span class="item_field">{{ $t('dealerForm.phone') }} <i style="color:red">*</i></span>
                                    <input type="text" class="form_input" :style="{width:'245px'}" maxlength="50" v-model="formData.phone">
                                </div>
                                <div class="form_item_sub">
                                    <span class="item_field" style="width: 70px">{{ $t('dealerForm.mobile') }} </span>
                                    <input type="text" class="form_input" :style="{width:'240px'}" maxlength="50" v-model="formData.mobile">
                                </div>
                            </div>
                            <div class="form_item">
                                <div class="form_item_sub">
                                    <span class="item_field">{{ $t('dealerForm.email') }} <i style="color:red">*</i></span>
                                    <input type="text" class="form_input" :style="{width:'260px'}" maxlength="100" v-model="formData.email">
                                </div>
                                <div class="form_item_sub">
                                    <span class="item_field" style="width: 70px">{{ $t('dealerForm.website') }} </span>
                                    <input type="text" class="form_input" :style="{width:'225px'}" maxlength="100" v-model="formData.website">
                                </div>
                            </div>  
                            <div class="form_item">
                                <div class="form_item_sub">
                                    <span class="item_field">{{ $t('dealerForm.vatNo') }}</span>
                                    <input type="text" class="form_input" :style="{width:'260px'}" maxlength="100" v-model="formData.vat_no">
                                </div>
                            </div>  
                    </div>
                    <div class="form form2">
                            <div class="form_item">
                                <span class="item_field">{{ $t('dealerForm.storeAddress') }} <i style="color:red">*</i></span>
                                <input type="text" class="form_input" :style="{width:'585px'}" maxlength="500" v-model="formData.store_address">
                            </div>
                            <div class="form_item">
                                <span class="item_field">{{ $t('dealerForm.deliveryAddress') }} <i style="color:red">*</i></span>
                                <input type="text" class="form_input" :style="{width:'585px'}" maxlength="500" v-model="formData.delivery_address">
                            </div>
                            <div class="form_item">
                                <span class="item_field">{{ $t('dealerForm.salesAreaApprox') }} </span>
                                <input type="text" class="form_input" :style="{width:'300px'}" maxlength="36" v-model="formData.sales_area_approx">  m²
                            </div>
                            <div class="form_item">
                                <span class="item_field">{{ $t('dealerForm.branches') }} <i style="color:red">*</i></span>
                                    <div class="form_item_sub" style="width:135px;vertical-align: bottom">
                                        <input type="checkbox" v-model="branchesNo" @change="changeBranches('NO')" class="form_checkbox" style="vertical-align: bottom">
                                        <span class="item_radio">{{ $t('dealerForm.No') }}</span>
                                    </div>
                                    <div class="form_item_sub">
                                        <input type="checkbox" v-model="branchesYes" @change="changeBranches('YES')" class="form_checkbox" style="vertical-align: bottom">
                                        <span class="item_radio" >{{ $t('dealerForm.branchesRemark') }}</span>
                                        <input type="text" class="form_input" :style="{width:'265px'}" maxlength="255" v-model="formData.branches_remark">
                                    </div>
                            </div>
                            <div class="form_item">
                                <span class="item_field">{{ $t('dealerForm.serviceWorkshop') }} <i style="color:red">*</i></span>
                                    <div class="form_item_sub" style="width:135px">
                                        <input type="checkbox" v-model="serviceWorkshopYes" @change="changeServiceWorkshop('YES')" class="form_checkbox" style="vertical-align: bottom;">
                                        <span class="item_radio">{{ $t('dealerForm.Yes') }}</span>
                                    </div>
                                    <div class="form_item_sub" style="width:150px">
                                        <input type="checkbox" v-model="serviceWorkshopNo" @change="changeServiceWorkshop('NO')" class="form_checkbox" style="vertical-align: bottom;">
                                        <span class="item_radio">{{ $t('dealerForm.No') }}</span>
                                    </div>
                            </div>
                            <div class="form_item">
                                <span class="item_field">{{ $t('dealerForm.yearOfFoundation') }} </span>
                                <input type="text" class="form_input" :style="{width:'585px'}" maxlength="500" v-model="formData.foundation">
                            </div>
                            <div class="form_item">
                                <span class="item_field">{{ $t('dealerForm.portfolio') }} </span>
                                <input type="text" class="form_input" :style="{width:'585px'}" maxlength="500" v-model="formData.portfolio">
                            </div>
                    </div>
                    <div class="confirm">
                        <input type="checkbox" v-model="confirm" class="form_checkbox form_checkbox_confirm">
                        <span class="confirmMsg" style="{width:30px,verticalAlign: bottom}">{{ $t('dealerForm.confirmTip') }}</span>
                    </div>
                    <div class="signature">
                        <div class="date" @click="openSign('date')">
                            <span class="item_field" >{{ $t('dealerForm.signDate') }}</span>
                            <div class="line resultImgLine">
                                <img :src="dateResultImg" class="resultImg" width="" height="">
                            </div>  
                        </div>
                        <div class="name" @click="openSign('name')">
                            <span class="item_field" >{{ $t('dealerForm.signName') }}</span>
                            <div class="line resultImgLine">
                                <img :src="nameResultImg" class="resultImg" width="" height="">
                            </div>
                        </div>
                    </div>
                </a-watermark>
            </div>
            <div class="submitSuccess" v-if="submitSuccess && tokenIsEffect">
                <icon-check-circle size="100"/>
                <p>{{ $t('dealerForm.submitSuccessful') }}</p> 
            </div>
            <div class="tokenIsEffect" v-if="!tokenIsEffect">
                <icon-info-circle-fill size="100"/>
                <p>{{ $t('dealerForm.linkExpired') }}</p> 
            </div>
        </a-spin >

        <!-- 在线签名 -->
        <div v-if="showSign" class="signContainerMask"  @click="showSign = false"></div>
        <div class="signContainer" v-if="showSign">
                <vue-esign 
                    class="esign"
                    ref="esign" 
                    :width="sign.width" 
                    :height="sign.height" 
                    :isCrop="sign.isCrop" 
                    :lineWidth="sign.lineWidth" 
                    :lineColor="sign.lineColor" 
                    v-model:bgColor="sign.bgColor" 
                />
                <div class="signBtn">
                    <a-button class="clear" @click="showSign = false">{{ $t('dealerForm.close') }}</a-button>
                    <a-button class="clear" @click="handleReset">{{ $t('dealerForm.empty') }}</a-button>
                    <a-button type="primary" class="clear" @click="handleGenerate">{{ $t('dealerForm.generateImages') }}</a-button>
                </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, reactive, nextTick, onMounted, h } from 'vue';
    import html2Canvas from 'html2canvas'
    import JsPDF from 'jspdf'
    import vueEsign from 'vue-esign'
    import { DealerApi } from '@/api/DealerApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import { decryption } from '@/utils/index.js';
    import axios from 'axios';
    import { useI18n } from 'vue-i18n';
    import { getParam } from '@/utils/index'

    const i18n = useI18n();
    const { t } = useI18n()

    const BASE_API_URL = import.meta.env.VITE_BASE_URL
    const TOKEN = getParam(window.location.href, 'type') == 'link'? decryption(window.location.href.split('key')[1].split('=')[1]) : window.location.href.split('key')[1].split('=')[1]
    console.log(TOKEN,'token')

    const formData = reactive({
        company_name:'',
        contact_person:'',
        street:'',
        house_number:'',
        zip:'',
        location:'',
        country:'',
        city:'',
        phone:'',
        mobile:'',
        email:'',
        website:'',
        vat_no:'',
        store_address:'', // 店铺店址
        delivery_address:'', // 收货地址
        branches_remark:'',//分支备注
        sales_area_approx:'',//销售面积
        branches:'', // 是否分支
        service_workshop:'', // 是否服务车间
        foundation:'',// 成立年份
        portfolio:'',// 投资TOP品牌
        file:'',
        country_code:'',
    })
    const branchesNo = ref(false)
    const branchesYes = ref(false)
    const serviceWorkshopNo = ref(false)
    const serviceWorkshopYes = ref(false)
    const confirm = ref(false)
    const imgData = ref(null)
    const loading = ref(false)
    const sign = reactive({
        width:1200,
        height:400,
        lineWidth: 6,
        lineColor: '#000000',
        bgColor: '#fff',
        resultImg: '',
        isCrop: true, // 是否剪裁
    })
    const dateResultImg = ref('') 
    const nameResultImg = ref('')
    const esign = ref(null)
    const showSign = ref(false)
    const sign_type = ref('')
    const countryOptions = ref([])
    const showCountrySelect = ref(false)
    const submitSuccess = ref(false)
    const tokenIsEffect = ref(true)
    const fullscreen = ref(false)

    const language = localStorage.getItem('locale')? ref(localStorage.getItem('locale')) : ref('en')

    const switchLanguage = (val)=>{
        localStorage.setItem('locale',val)
        localStorage.setItem('isDealerForm',true)
        i18n.locale.value = val
    }

    const selectCountry = (val)=>{
        let item = countryOptions.value.find(i=> i.value == val)
        formData.country = item.label
        showCountrySelect.value = false
    }

    const changeBranches = (val)=>{
        if(val == 'NO'){
            branchesYes.value = false
            formData.branches = val
        } 
        if(val == 'YES'){
            branchesNo.value = false
            formData.branches = val
        } 
    }

    const changeServiceWorkshop = (val)=>{
        if(val == 'NO'){
            serviceWorkshopYes.value = false
            formData.service_workshop = val
        } 
        if(val == 'YES'){
            serviceWorkshopNo.value = false
            formData.service_workshop = val
        }
    }

    const getFullscreen = ()=>{
        fullscreen.value = !fullscreen.value
        width.value = 2000
        height.value = 800
    }

    // 生成图片
    const getPdf = ()=>{
        var dom = document.getElementById("pdfHtml");  // 生成pdf的html内容
        html2Canvas(dom, {
            allowTaint: true,
            scrollY: 0,
            scrollX: 0,
            useCORS: true, // 开启跨院
            width: 900, // 这个宽度，太扯淡了，固定1000，防止偏移！
            height: dom.offsetHeight,
            background:'#fff',
            scale:2,
        }).then( (canvas) =>{
            imgData.value = canvas.toDataURL('image/jpeg', 1.0) // 将图片转为base64, 0-1 表示清晰度
            // var oA = document.createElement("a");
            // oA.download = '';// 设置下载的文件名，默认是'下载'
            // oA.href = imgData.value;
            // document.body.appendChild(oA);
            // oA.click();
            // oA.remove(); // 下载之后把创建的元素删除
            uploadFile(imgData.value,'Dealer Info Form')
        });
    }

    // base64图片对象转File对象
    const dataURLtoFile = (dataurl,filename)=> {
        let arr = dataurl.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while(n--){
          u8arr[n] = bstr.charCodeAt(n);
        }
        //转换成file对象
        return new File([u8arr], filename, {type:mime});
    }

    // 上传图片到文件服务器
    const uploadFile = async (dataurl,filename)=>{
        let form = new FormData();
        form.append("file", dataURLtoFile(dataurl,filename))
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + TOKEN,
            },
            method: 'POST',
            timeout: 6 * 60 * 1000,
            url: BASE_API_URL + '/order/module/upload',
            data: form,
        }
        axios(config).then(res => {
            if (res.data.code == 0) {
                formData.file = res.data.data
                saveDealer()
            }else{
                Message.error(res.data.msg)
            }
        }).catch(error => { 
            Message.error(error)
        })
    }

    // 打开签名
    const openSign = (type)=>{
        sign_type.value = type
        showSign.value = true
    }

    // 签名-清空签名
    const handleReset = ()=> {
        esign.value.reset()
    }

    // 签名-生成图片
    const handleGenerate= ()=> {
        esign.value.generate().then(res => {
            if(sign_type.value == 'date') dateResultImg.value = res
            if(sign_type.value == 'name') nameResultImg.value = res
            showSign.value = false
        }).catch(err => {
            Message.error(err) // 画布没有签字时会执行这里 'Not Signned'
        })
    }

    // 校验
    const valid = ()=>{
        let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ 
        console.log(reg.test(formData.email),'mmkkkkkk')
        if(!formData.company_name){
            Message.error(t('dealerForm.companyName')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.contact_person){
            Message.error(t('dealerForm.contactPerson')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.street){
            Message.error(t('dealerForm.street')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.house_number){
            Message.error(t('dealerForm.houseNumber')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.zip){
            Message.error(t('dealerForm.zipCode')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.country){
            Message.error(t('dealerForm.country')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.city){
            Message.error(t('dealerForm.city')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.phone){
            Message.error(t('dealerForm.phone')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.email){
            Message.error(t('dealerForm.email')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!reg.test(formData.email)){
            Message.error(t('dealerForm.emailError')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.store_address){
            Message.error(t('dealerForm.storeAddress')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.delivery_address){
            Message.error(t('dealerForm.deliveryAddress')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.branches){
            Message.error(t('dealerForm.branches')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!formData.service_workshop){
            Message.error(t('dealerForm.serviceWorkshop')+' '+t('dealerForm.notEmpty'))
            return false
        }else if(!dateResultImg.value || !nameResultImg.value){
            Message.error(t('dealerForm.signConfirm'))
            return false
        }

        return true
    }

    // 提交
    const submit = ()=>{
        if(!valid()) return
        Modal.warning({
            title: t('dealerForm.tip'),
            titleAlign:'start',
            hideCancel:false,
            width:350,
            content: ()=> h('div',{},[
                h('p',`${t('dealerForm.submitTip')}`),
                h('p',`${t('dealerForm.submitTip2')}`),
            ]),
            okText:t('dealerForm.ok'),
            cancelText:t('dealerForm.cancel'),
            onOk:()=>{
                loading.value = true
                getPdf()
            }
        })
        
    }

    // 保存表单
    const saveDealer = async()=>{
        console.log(formData,'param')
        let config = {
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + TOKEN,
            },
            method: 'POST',
            timeout: 6 * 60 * 1000,
            url: BASE_API_URL + '/dealer/save',
            data: formData,
        }
        axios(config).then(res => {
            console.log(res,'res')
            if (res.data.code == 0) {
                loading.value = false
                submitSuccess.value = true
            }else{
                loading.value = false
                Message.error(res.args[0])
            }
        }).catch(error => { 
            console.log(error,'error')
            loading.value = false
            Message.error(error.response.data.args[0])
        })
    }

    // 校验token是否失效
    const validToken = ()=>{
        let config = {
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            method: 'GET',
            timeout: 6 * 60 * 1000,
            url: BASE_API_URL + `/auth/check/token?token=${TOKEN}`,
            data: {},
        }
        axios(config).then(res => {
            if (res.data.code == 0) {
                tokenIsEffect.value = true
            }else{
                tokenIsEffect.value = false
                Message.error(res.data.msg)
            }
        }).catch(error => { 
            tokenIsEffect.value = false
        })
    }

    // 获取国家
    const getCountry = async()=>{
        let config = {
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + TOKEN,
            },
            method: 'POST',
            timeout: 6 * 60 * 1000,
            url: BASE_API_URL + '/system/country/query',
            data: {
                enable_flag:1,
            },
        }
        axios(config).then(res => {
            if (res.data.code == 0) {
                res.data.data.length > 0 && res.data.data.forEach(i=>{
                    countryOptions.value.push({
                        label:i.country,
                        value:i.country_code
                    })
                })
            }else{
                Message.error(res.data.msg)
            }
        })
    }

    onMounted(async ()=>{
        await validToken()
        getCountry()
    })

    


</script>

<style lang="less" scoped>
/deep/ .arco-spin{
    display: block;
}
.content{
    padding: 20px;
    box-sizing: border-box;

    .container{
        margin: 28px auto;
        padding: 20px 60px;
        width: 800px;
        height: 1150px;
        box-shadow: 0px 0px 10px -6px #333;
        background: #fff;

        .logo{
            float: right;
        }

        .title{
            margin:75px 60px 40px;
            width: 61%;
            color: #000;
            
            .title_hd{
                margin-bottom: 10px;
                font-size: 30px;
                font-weight: bold;
            }

            .title_content{
                font-size: 15px;
                font-weight: 520;
            }
        }

        .form{
            margin-left: -30px;
            margin-bottom: 50px;
            .form_item{
                margin:18px;
                .form_item_sub{
                    display: inline-block;
                }

                .item_field{
                    display: inline-block;
                    width: 175px;
                    text-align: right;
                    font-weight: bold;
                    vertical-align: bottom;
                }
                .form_input{
                    margin-left: 10px;
                    padding: 3px 10px;
                    border: none;
                    border-bottom:1px solid #000;
                    outline: none;
                }
                .item_radio{
                    margin-left: 5px;
                    width: 40px;
                    font-weight: bold;
                    vertical-align: bottom;
                }

                .form_checkbox{
                    margin: 0 20px;
                    cursor: pointer;
                }

                .select{
                    display: inline-block;
                    position: relative;
                    /deep/ .arco-select-view-single{
                        background: #fff;
                        border-bottom: 1px solid #000;
                        
                    }
                    /deep/ .arco-select-view-single:focus-within, 
                    /deep/ .arco-select-view-single.arco-select-view-focus{
                        border:none;
                    }
                }
               

                /deep/ .arco-input-wrapper,
                /deep/ .arco-input{
                    background: #fff;
                    border: none;
                    
                }

                /deep/ .arco-input-wrapper{
                    border-bottom: 1px solid #333;
                }
            }
        }

        .confirm{
            display: flex;
            margin-left: 105px;
            width: 65%;
            

            .confirmMsg{
                display: flex;
                margin-left: 30px;
                font-weight: bold;
            }

            input[type="checkbox"]::after {
                width: 25px;
                height: 25px;
                content: " ";
                display: inline-block;
                visibility: visible;
                border-radius: 2px;
                margin: 15px 10px 0 0;
                padding: 1px 2px;
                box-sizing: border-box;
                background-color: #fff;
                color: #fff;
                border: 2px solid #000;   
                cursor: pointer;    
            }

            input[type="checkbox"]:checked::after{
                content:"√";
                cursor: pointer;
                font-size: 23px;
                font-weight: 700;
                background-color: #fff;
                color: #000;
            }
        }

        /deep/ .arco-checkbox-icon{
            width:25px;
            height: 25px;
            border: 2px solid #000;
        }

        /deep/ .arco-checkbox-icon-check{
            padding: 3px;
            background: #fff;
            width:15px;
            height: 75%;
            color: #000;
        }

        input[type="checkbox"]::after {
            width: 25px;
            height: 25px;
            content: " ";
            display: inline-block;
            visibility: visible;
            border-radius: 2px;
            margin: -9px 0 0 0;
            padding: 1px 2px;
            box-sizing: border-box;
            background-color: #fff;
            color: #fff;
            border: 2px solid #000;       
        }

        input[type="checkbox"]:checked::after{
            content:"√";
            cursor: pointer;
            font-size: 23px;
            font-weight: 700;
            background-color: #fff;
            color: #000;
        }


        .signature{
            margin-top: 80px;
            margin-left: 60px;

            .date,.name{
                display: inline-block;
                margin: 0 25px;
                cursor: pointer;
            }

            .item_field{
                font-size: 13px;
                font-weight: bold;
            }

            .line{
                display:inline-block;
                margin-left:15px;
                width: 220px;
                border-bottom: 1px solid #000;
            }
        }
    }

    .operateBtn{
        position: fixed;
        top: 0px;
        left: 50%;
        z-index: 99;
        width: 920px;
        padding: 10px;
        margin-left: -460px;
        box-sizing: border-box;
        text-align: center;
        background:#fff;
        border-bottom:1px solid #ccc;
        box-shadow: 0px 0px 10px -6px #333;

        .submit,.language{
            float: left;
            margin-right: 10px;
            outline: none;
        }
    }

    /deep/ .arco-select-view-single{
        height: 28px;
    }
}

.signContainerMask{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: .6;
}

.signContainer{
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1000;
    margin-left: -585px;
    margin-top:-250px;
    background: #fff;

    .signBtn{
        padding: 10px;
        width: 100%;
        text-align: center;
        border-top: 1px solid #ccc;
        box-sizing: border-box;

        .clear{
            margin-right: 10px;
            outline: none;
        }
    }
}

.submitSuccess,
.tokenIsEffect{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 100px;
    margin-left: -100px;
    margin-top: -150px;
    color:#91cc75;
    text-align: center;
}

.tokenIsEffect{
    color:#fac858;
}

.resultImg{
    transform: scale(.9);
    max-width: 185px;
    max-height:50px;
}
.resultImgLine{
     width: 200px;
     max-height: 100px;
}

</style>